$('body').tooltip({
    selector: '[data-bs-toggle="tooltip"]',
    trigger: 'hover',
});
